import { createContext, useContext, useState } from "react";
import Notification from './../components/Notification';

const NotificationContext = createContext(null);

export function NotificationProvider({ children }) {
    const [notification, setNotification] = useState(null);

    const notify = (message, status = "info") => {
        setNotification({
            message,
            status,
        });

        setTimeout(() => {
            setNotification(null);
        }, 3000);
    };

    return (
        <NotificationContext.Provider value={{ notify }}>
            {children}

            {notification && (
                <Notification
                    message={notification.message}
                    status={notification.status}
                />
            )}
        </NotificationContext.Provider>
    );
}

export function useNotification() {
    return useContext(NotificationContext);
}